import { Component, OnInit } from '@angular/core';
import {
  ControlContainer,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { Entity } from 'src/app/shared/store/view/types';
import { DropdownStyle } from '../../../../../../shared/store/typeahead/types';
import { ReferralCampaign } from '../../../../../../shared/store/campaign/types';
import {
  removeValidators,
  setValidators,
} from '../../../../../../shared/helper/formhelper';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filterTrue } from '../../../../../../shared/pipe/rxjs/operators';
import { UserService } from '../../../../../../shared/store/user/user.service';

@UntilDestroy()
@Component({
  selector: 'app-contact-form-marketing',
  templateUrl: './contact-form-marketing.component.html',
  styleUrls: ['./contact-form-marketing.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  standalone: false,
})
export class ContactFormMarketingComponent implements OnInit {
  createContactFormModel$: Observable<unknown>;
  isCampaignReferral: boolean;
  form: FormGroup;

  userMainSalesTeamId$: Observable<number | undefined>;

  protected readonly Entity = Entity;
  protected readonly DropdownStyle = DropdownStyle;

  constructor(
    private parent: FormGroupDirective,
    private formBuilder: FormBuilder,
    private readonly userService: UserService,
  ) {
    this.userMainSalesTeamId$ = this.userService.getMainSalesTeamById.value$;
    // this.createContractFormModel$ =
    //   this.contractService.getContractModel.value$;
  }

  ngOnInit(): void {
    this.isCampaignReferral = false;
    this.form = this.parent.form;
    this.form.addControl(
      'marketingFormGroup',
      this.formBuilder.group({
        marketingCampaignId: [undefined],
        marketingMediumId: [undefined],
        marketingSourceId: [undefined],
        marketingCreationDate: [''],
        salesTeamId: [undefined],
        salesPersonId: [undefined],
        marketingReferrerId: [undefined],
      }),
    );

    // this.createContractFormModel$.pipe(filter((x) => !!x)).subscribe((x) => {
    //   this.form.patchValue({
    //     marketingFormGroup: {
    //       marketingSource: x.contractFormModel.source,
    //     },
    //   });
    // });

    this.form.controls['marketingFormGroup']
      .get('marketingCampaignId')
      ?.valueChanges.subscribe((x) => {
        if (x == ReferralCampaign) {
          this.isCampaignReferral = true;

          setValidators(
            this.form.controls['marketingFormGroup'].get('marketingReferrerId'),
            Validators.required,
          );
        } else {
          this.isCampaignReferral = false;

          removeValidators(
            this.form.controls['marketingFormGroup'].get('marketingReferrerId'),
            Validators.required,
          );
        }
      });

    this.form.controls['marketingFormGroup']
      .get('salesPersonId')
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe((value) => {
        if (!!value) {
          this.userService.getMainSalesTeamById.call(value);
        } else {
          this.form.patchValue({
            marketingFormGroup: {
              salesTeamId: undefined,
            },
          });
        }
      });

    this.userMainSalesTeamId$
      .pipe(filterTrue(), untilDestroyed(this))
      .subscribe((mainSalesTeamId) => {
        if (!!mainSalesTeamId)
          this.form.patchValue({
            marketingFormGroup: {
              salesTeamId: mainSalesTeamId,
            },
          });
      });
  }
}
